import type { ReactNode } from "react";
import { marketingContainerClassName } from "./marketing-layout";
import { SiteFooter } from "./site-footer";
import { SiteHeader } from "./site-header";

export const primaryCtaClassName =
  "inline-flex items-center justify-center rounded-md border border-brand bg-brand px-4 py-2.5 text-sm font-medium text-white outline-brand hover:bg-brand-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2";

export const secondaryCtaClassName =
  "inline-flex items-center justify-center rounded-md border border-zinc-300 bg-white px-4 py-2.5 text-sm font-medium text-zinc-800 outline-brand hover:border-zinc-400 hover:bg-zinc-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2";

type StatusPageProps = {
  title: string;
  description: ReactNode;
  actions: ReactNode;
  detail?: ReactNode;
};

export function StatusPage({
  title,
  description,
  actions,
  detail,
}: StatusPageProps) {
  return (
    <main className="flex min-h-dvh flex-1 flex-col bg-zinc-100 text-zinc-950">
      <SiteHeader />
      <section
        aria-labelledby="status-page-heading"
        className="flex flex-1 flex-col justify-center border-b border-zinc-200 bg-white py-10 md:py-14"
      >
        <div className={marketingContainerClassName}>
          <h1
            id="status-page-heading"
            className="text-3xl font-bold tracking-tight text-zinc-950 md:text-4xl"
          >
            {title}
          </h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-zinc-600">
            {description}
          </p>
          {detail}
          <div className="mt-8 flex flex-wrap gap-3">{actions}</div>
        </div>
      </section>
      <SiteFooter />
    </main>
  );
}
